export const articles = [
  {
    id: 'a1',
    slug: 'nenxiaotu-brand-story',
    title: '嫩小兔的诞生：一只兔子如何治愈了千万年轻人',
    excerpt: '从一张随手涂鸦到风靡全网的萌系IP，嫩小兔的诞生故事就像一个温暖的童话。让我们一起回顾这只软萌兔子的奇妙旅程。',
    content: `<p>2019年的一个午后，创始人小鹿在咖啡馆的纸巾上随手画下了一只软绵绵的小兔子——圆圆的脸蛋、长长垂下的耳朵、粉扑扑的腮红。她给它取名"嫩小兔"，希望它能传递一种软萌、温暖、治愈的力量。</p>
<p>没有人想到，这只诞生在纸巾上的小兔子，会在短短几年间成为风靡中国年轻人群体的萌系潮流IP。</p>
<h4>从涂鸦到潮流符号</h4>
<p>嫩小兔最初的设定很简单：它住在一个名叫"棉花云"的小镇上，每天和朋友们一起探险、吃胡萝卜蛋糕、收集星星。小鹿将嫩小兔的日常画成四格漫画发布在社交媒体上，没想到第一天就收获了上万点赞。</p>
<p>"可能是这个时代太焦虑了，"小鹿说，"大家需要一些柔软的东西来缓冲生活的锋利。"</p>
<p>2020年，嫩小兔推出了第一款实体玩偶——限量500只，3分钟售罄。从此，这只兔子走上了从虚拟IP到实体潮玩的蜕变之路。</p>
<h4>嫩小兔的"萌系哲学"</h4>
<p>在小鹿看来，萌不仅仅是可爱，更是一种生活态度。"萌是温柔的坚持，是用柔软的方式面对世界的勇气。我们希望每个拥有嫩小兔的人，都能在忙碌的生活中找到一刻治愈。"</p>
<p>带着这样的理念，嫩小兔团队不断推出新品：从最初的单款玩偶，发展到涵盖毛绒玩具、生活周边、联名合作、限定礼盒的完整产品线。每一次新品发布，都是一次与粉丝共同创造的"萌趣事件"。</p>
<h4>未来：不止是玩具</h4>
<p>2026年，嫩小兔已经成为一个拥有超过500万社交媒体粉丝的萌系潮流品牌。团队正在筹划嫩小兔主题咖啡馆、动画短片、线下快闪店等更多元的体验场景。</p>
<p>"我们希望嫩小兔不仅仅是一个玩具，而是一种陪伴。"小鹿的眼神里闪着光，"就像那只最初画在纸巾上的兔子一样——简单、温暖、治愈人心。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20illustration%20of%20a%20small%20cute%20white%20rabbit%20drawn%20on%20a%20napkin%20on%20a%20cafe%20table%2C%20soft%20sunlight%20streaming%20through%20window%2C%20coffee%20cup%20nearby%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20dreamy%20atmosphere%2C%20artistic%20illustration%20style&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-06-15',
    readTime: '5分钟',
    category: '品牌故事',
    tags: ['嫩小兔', '品牌故事', '萌系潮流'],
  },
  {
    id: 'a2',
    slug: 'plush-toy-care-guide',
    title: '嫩小兔玩偶养护全攻略：让你的兔兔永远软萌如初',
    excerpt: '入手了心爱的嫩小兔玩偶却不知道怎么保养？这篇超详细养护指南，让你的兔兔陪伴更长久。',
    content: `<p>每一个嫩小兔玩偶都是粉丝的"心头好"，但毛绒玩具如果不注意保养，很容易变脏、变形甚至滋生细菌。今天我们就来分享一套完整的嫩小兔玩偶养护秘籍。</p>
<h4>日常清洁三步走</h4>
<p><strong>第一步：表面除尘</strong>——每周用粘毛滚筒或软毛刷轻轻刷去玩偶表面的灰尘和毛发。注意顺着绒毛方向刷，不要来回用力摩擦。</p>
<p><strong>第二步：局部清洁</strong>——小面积污渍可用湿毛巾蘸取少量中性洗涤剂轻轻擦拭，然后用清水毛巾擦净，自然晾干。千万不要用力揉搓！</p>
<p><strong>第三步：深度清洗</strong>——建议每3-6个月深度清洗一次。手洗最佳：30℃温水+中性洗涤剂，轻轻按压清洗，不要拧绞。洗后用干毛巾吸去多余水分，放在通风处自然晾干。</p>
<p>⚠️ 重要提示：嫩小兔玩偶不可机洗！不可暴晒！不可烘干！不可使用漂白剂！</p>
<h4>收纳小技巧</h4>
<p>长期不玩的嫩小兔，建议用透气的棉布袋收纳，放在干燥阴凉处。避免用塑料袋密封，也不要压在重物下面——我们的兔兔需要呼吸哦！</p>
<h4>变形了怎么办？</h4>
<p>如果玩偶因为长时间挤压变形，可以试着用吹风机冷风档吹蓬绒毛，然后用手轻轻拍打恢复蓬松。填充物移位的话，可以从缝合处小心拆开，重新整理填充物后缝好。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20plush%20rabbit%20toy%20being%20gently%20brushed%20with%20a%20soft%20brush%20on%20a%20clean%20surface%2C%20surrounded%20by%20cleaning%20tools%2C%20warm%20sunlight%2C%20pastel%20pink%20and%20white%20color%20scheme%2C%20cozy%20home%20setting%2C%20soft%20photography%20style&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-05-20',
    readTime: '4分钟',
    category: '养护指南',
    tags: ['玩偶养护', '清洁', '嫩小兔'],
  },
  {
    id: 'a3',
    slug: 'new-release-2026-spring',
    title: '2026春季新品大公开！嫩小兔梦幻花园系列来了',
    excerpt: '嫩小兔2026春季新品"梦幻花园"系列正式发布！全新配色、全新造型，带你走进嫩小兔的春日童话世界。',
    content: `<p>春暖花开，嫩小兔也要换新装啦！2026年春季，我们隆重推出"梦幻花园"主题系列，包含多款全新产品，每一件都承载着春天的气息。</p>
<h4>梦幻星空限定玩偶</h4>
<p>本季主打的梦幻星空限定玩偶，采用渐变蓝紫色绒毛，耳朵上点缀着立体星星刺绣。每一只都有专属编号，全球限量3000只。小鹿说：&ldquo;这只兔兔的灵感来自春天的夜空——清澈、深邃，闪烁着希望的光芒。&rdquo;</p>
<h4>春日花园限定礼盒</h4>
<p>如果你想要一次集齐春日的美好，春日花园限定礼盒是最佳选择。礼盒内含限定玩偶钥匙扣、香薰蜡烛（茉莉花香味）、兔兔贴纸套装和手写祝福卡。包装采用手绘花园插画，打开就像翻开一本春天的童话书。</p>
<h4>樱花季徽章套装</h4>
<p>樱花季限定徽章套装也是本次的亮点之一。5枚不同造型的嫩小兔樱花徽章，珐琅工艺搭配金色包边，无论是别在帆布袋、外套还是帽子上，都能瞬间点亮日常穿搭。</p>
<p>所有春季新品已在嫩小兔官方商城开启预售，前500名下单还可获赠限定樱花贴纸一张。快来把春天带回家吧！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20spring%20garden%20themed%20flat%20lay%20with%20cute%20rabbit%20plush%20toys%20and%20floral%20decorations%2C%20cherry%20blossoms%2C%20pastel%20pink%20and%20lavender%20color%20scheme%2C%20soft%20natural%20light%2C%20dreamy%20spring%20atmosphere%2C%20product%20photography%20style&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-04-10',
    readTime: '3分钟',
    category: '新品发布',
    tags: ['春季新品', '梦幻花园', '嫩小兔'],
  },
  {
    id: 'a4',
    slug: 'gift-guide-valentine',
    title: '送礼指南：用嫩小兔传递最治愈的心意',
    excerpt: '不知道送什么礼物给TA？嫩小兔送礼全攻略，从闺蜜生日到情侣纪念日，总有一款适合你。',
    content: `<p>送礼是一门艺术，而嫩小兔就是这门艺术中最治愈的"作品"。无论是什么场合，一只软萌的嫩小兔总能传递最温暖的心意。来看看我们的送礼指南吧！</p>
<h4>生日惊喜：生日派对惊喜礼盒</h4>
<p>如果TA的生日快到了，生日派对惊喜礼盒绝对是不二之选。中号嫩小兔玩偶、定制蛋糕蜡烛、兔兔发箍、立体贺卡——打开礼盒的瞬间，就是满满的仪式感和萌趣。399元的价格，换TA一个大大的笑容。</p>
<h4>闺蜜告白：迷你盲盒系列</h4>
<p>想给闺蜜一个惊喜？迷你盲盒系列了解一下！6款不同造型的嫩小兔，每一只都可爱到犯规。拆盲盒的快乐+收集的成就感=双倍治愈。59元一盒，买一套送闺蜜，一起分享拆盒的快乐！</p>
<h4>情侣纪念：联名限定款</h4>
<p>对于特别的人，当然要送特别的礼物。嫩小兔联名系列产品每一款都是限量的，独特的设计让这份礼物更加珍贵。比如嫩小兔×薄荷糖联名T恤，穿上它就是最甜的CP装。</p>
<h4>日常小惊喜：樱花徽章套装</h4>
<p>不需要特殊节日才能送礼，日常的小惊喜更能打动人心。49元的樱花徽章套装，精致又实用，随手送出就能收获满满的感动。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautifully%20wrapped%20gift%20box%20with%20pastel%20pink%20ribbon%20and%20cute%20rabbit%20theme%2C%20surrounded%20by%20small%20plush%20rabbits%20and%20heart%20decorations%2C%20soft%20warm%20lighting%2C%20romantic%20cozy%20atmosphere%2C%20product%20photography&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-03-14',
    readTime: '4分钟',
    category: '送礼指南',
    tags: ['送礼', '礼物推荐', '嫩小兔'],
  },
  {
    id: 'a5',
    slug: 'collaboration-mint-artist',
    title: '跨界对话：嫩小兔×薄荷糖联名背后的创作故事',
    excerpt: '嫩小兔首次联名合作选择了人气插画师薄荷糖，两大萌系IP的碰撞带来了怎样的火花？我们采访了两位创作者。',
    content: `<p>2026年初，嫩小兔宣布了品牌成立以来的首次跨界联名——与人气插画师"薄荷糖"合作推出联名系列。消息一出，粉丝们沸腾了：两大萌系IP的碰撞，会产生怎样的化学反应？</p>
<h4>缘起：一次私信引发的合作</h4>
<p>"其实是薄荷糖先发了一条私信给我们。"小鹿笑着回忆，"她说自己一直是嫩小兔的粉丝，画了好多嫩小兔的同人图。我们一看，哇，画得太可爱了，合作立刻就提上了日程。"</p>
<p>薄荷糖以清新薄荷绿色调和软萌画风著称，在社交平台拥有超过200万粉丝。她的作品总给人一种"清甜"的感觉——就像夏天的薄荷糖，沁人心脾。</p>
<h4>创作过程：兔兔遇上薄荷</h4>
<p>"我一直在想，嫩小兔和我的风格该怎么融合。"薄荷糖说，"后来我想到了——让嫩小兔抱着我最爱的薄荷糖罐子，周围飞舞着糖果和花瓣。这样既保留了嫩小兔的软萌，也融入了我的薄荷元素。"</p>
<p>联名系列的第一款产品是T恤，图案正是薄荷糖设计的嫩小兔抱糖罐。清新薄荷绿底色上，粉白相间的嫩小兔探出脑袋，画面既灵动又有治愈感。</p>
<h4>粉丝反响：秒空的联名款</h4>
<p>联名T恤限量1000件，上架后3分钟售罄。没抢到的粉丝在评论区"哭成一片"，团队紧急加开了预售通道。</p>
<p>"我们真的没想到反响这么好。"小鹿说，"这次合作让我们看到了嫩小兔在联名领域的无限可能。未来，我们还会和更多优秀创作者合作，让嫩小兔以更多元的形式陪伴大家。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creative%20studio%20desk%20with%20sketches%20of%20cute%20rabbit%20illustrations%20mixed%20with%20mint%20candy%20motifs%2C%20color%20pencils%2C%20mint%20green%20and%20pastel%20pink%20color%20palette%2C%20warm%20artistic%20atmosphere%2C%20soft%20lighting&width=1200&height=600&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-02-28',
    readTime: '4分钟',
    category: '联名故事',
    tags: ['联名', '薄荷糖', '嫩小兔'],
  },
  {
    id: 'a6',
    slug: 'collectors-guide',
    title: '嫩小兔入坑指南：从零开始的收藏家之路',
    excerpt: '想成为嫩小兔收藏家？这份入坑指南涵盖了从入门到进阶的所有知识点，帮你少走弯路。',
    content: `<p>嫩小兔的产品线越来越丰富，对于新入坑的粉丝来说，可能会有些眼花缭乱。别担心，这份入坑指南会带你从零开始，成为真正的嫩小兔收藏家。</p>
<h4>入门级（预算100元以内）</h4>
<p>推荐从贴纸套装（¥19）或徽章套装（¥49）开始。价格友好，而且这些小型周边非常适合日常使用和展示。贴在手账、电脑壳上，每天都能看到嫩小兔的可爱模样。</p>
<h4>进阶级（预算100-200元）</h4>
<p>这个价位推荐抱枕玩偶（¥89）或保温杯（¥99）。抱枕玩偶是嫩小兔最经典的产品线，36cm的尺寸无论是抱着睡觉还是装饰房间都很完美。保温杯则是实用与可爱兼得的日常好物。</p>
<h4>高端玩家（预算200元以上）</h4>
<p>限定礼盒（¥299起）是收藏家的终极目标。每一款限定礼盒都包含精心搭配的嫩小兔好物，而且限量发售，具有很高的收藏价值。</p>
<h4>收藏小贴士</h4>
<p>1. 关注嫩小兔官方社交媒体，第一时间获取新品预告和限量发售信息。</p>
<p>2. 保留产品包装和吊牌，完整的包装会让收藏品的价值翻倍。</p>
<p>3. 加入嫩小兔粉丝社群，和其他收藏家交流心得、交换稀有款。</p>
<p>4. 不要盲目追求数量，选择自己真正喜欢的系列深入收藏，才能享受收藏的真正乐趣。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautifully%20displayed%20collection%20of%20cute%20rabbit%20plush%20toys%20and%20accessories%20on%20wooden%20shelves%2C%20organized%20by%20size%20and%20color%2C%20pastel%20pink%20and%20cream%20color%20scheme%2C%20cozy%20room%20setting%2C%20soft%20warm%20lighting&width=1200&height=600&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-01-15',
    readTime: '5分钟',
    category: '收藏指南',
    tags: ['收藏', '入坑指南', '嫩小兔'],
  },
];